import { CancelToken } from 'axios'
import ApiErrors from '@/services/ApiErrors/ApiErrors'

class ApiRequest {
  constructor (requestFn, Model, options) {
    this.Model = Model
    this.error = null
    this.data = null
    this.loading = false
    this.options = options
    this.cancelFn = () => {}
    this.requestFn = requestFn
  }

  formatArguments (args) {
    return args
  }

  setError (error) {
    this.error = error
  }

  setLoading (loading) {
    this.loading = loading
  }

  setData (data) {
    this.data = data
  }

  setCancelFn (cancelFn) {
    this.cancelFn = cancelFn
  }

  clearData () {
    this.setData(null)
  }

  parsePayload (payload) {
    return (this.Model != null) ? new this.Model(payload) : payload
  }

  cancel () {
    this.cancelFn()
  }

  handleResponse ({ payload }) {
    this.setData(this.parsePayload(payload))
    this.setLoading(false)

    return this.data
  }

  handleError (error) {
    const apiErrors = new ApiErrors(error)

    this.setLoading(false)

    if (!apiErrors.isRequestCancelled) {
      this.clearData()
      this.setError(apiErrors)
    }

    throw apiErrors
  }

  execute (...args) {
    if (this.cancelFn != null) {
      this.cancel()
    }

    this.setError(null)
    this.setLoading(true)

    return this.requestFn(...this.formatArguments(args), {
      ...this.options,
      cancelToken: new CancelToken(this.setCancelFn.bind(this))
    })
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this))
  }
}

export default ApiRequest
